import React from 'react'

const About = () => {
  return (
    <div name='About' className='w-full h-dvh bg-gradient-to-b from-gray-800 to-black text-white'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-500'>About</p>
            </div>
            <p className='sm:text-xl text-sm mt-2 sm:mt-20'>
            Welcome to my portfolio! I am a passionate Computer Systems Engineer,
             a proud graduate of DUET, with a strong foundation in AI, Machine Learning,
              and Computer Vision.
           
            </p>
            <br/>
            <p className='sm:text-xl text-sm'>
            Currently, I am working as an <b>Associate Software Engineer</b> at <b>Geeks of Kolachi,</b>
             where I have gained over <b>1+ year of professional experience.</b> My work primarily focuses on
             <b> frontend development</b> using <b>React.js, Next.js,</b> and <b>mobile application development</b>
              with <b>React Native.</b> This hands-on experience has strengthened my ability to build scalable, user-centric web and mobile solutions.
             
            </p>
            
            <br/>
            <p className='sm:text-xl text-sm'>
            Previously, I completed impactful internships, including an <b>AI Internship</b> at the
               <b>Neural Computation Lab of Artificial Intelligence (NCAI) at NEDUET</b> and a <b>Web Development Internship</b> at <b>XR Vision.</b>
                These opportunities allowed me to apply my technical skills to real-world projects and deepen my understanding
                 of innovative technologies.
            </p>
            <br />
            <p className='sm:text-xl text-sm'>
            Beyond technical work, I have been actively involved in community and leadership initiatives, 
                 serving as Co-Lead at GDSC DUET '22 and contributing as a member of PEF and GFX at GYM.
Driven by a commitment to continuous learning and a passion for leveraging technology to create positive change, 
I am excited to keep exploring new frontiers in AI, Web, and Mobile development.
            </p>

        </div>
      
    </div>
  )
}

export default About
